import type { FullParcel } from '@coig/apm-api';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import { useState } from 'react';
import type { RouteComponentProps} from 'react-router';
import { SentPackage } from '../../components/sentPackage/SentPackage';
import { packageManagmentServices } from '../../services/packageManagmentServices';
import { useRequireAuth } from '../../utilities/authorization';

const putPackage: React.FC<FullParcel & RouteComponentProps<{packageId: string}>> = ({match}) => {
  useRequireAuth();

  const packageId = match.params.packageId;
  const [packageElement, setPackage] = useState({} as FullParcel);

  useIonViewWillEnter(async () => {
    const packageElement = await packageManagmentServices.getPackage(packageId);
    setPackage(packageElement);
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>To send</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">
              To send
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <SentPackage {...packageElement}
        ></SentPackage>
      </IonContent>
    </IonPage>
  );
};

export { putPackage as PutPackage };
